import { render, staticRenderFns } from "./AlunoInstituicaoGeral.vue?vue&type=template&id=18593b5c&"
import script from "./AlunoInstituicaoGeral.vue?vue&type=script&lang=js&"
export * from "./AlunoInstituicaoGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports